import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { BookMarked } from 'lucide-react';
import { API } from '../governance_v2/constants';
import { VERDICT_META } from './constants';

const useDebounced = (v, ms = 400) => {
  const [d, setD] = React.useState(v);
  React.useEffect(() => { const t = setTimeout(() => setD(v), ms); return () => clearTimeout(t); }, [v, ms]);
  return d;
};

/** "Decisiones similares del pasado": approved lessons matching module / KPI / text (deterministic retrieval). */
export const SimilarDecisions = ({ companyId, moduleType, kpiName, text, testid = 'similar-decisions' }) => {
  const q = useDebounced(text || '');
  const params = new URLSearchParams();
  if (moduleType) params.set('module_type', moduleType);
  if (kpiName) params.append('kpi_name', kpiName);
  if (q) params.set('q', q);
  const enabled = !!companyId && (!!moduleType || !!kpiName || q.length >= 4);
  const { data } = useQuery({
    queryKey: ['memory', 'similar', companyId, params.toString()], enabled,
    queryFn: async () => (await axios.get(`${API}/companies/${companyId}/memory/similar?${params}`)).data.items,
  });
  if (!enabled || !data?.length) return null;
  return (
    <div className="rounded-xl border border-indigo-300/50 bg-indigo-500/[0.06] p-3" data-testid={testid}>
      <p className="mb-2 flex items-center gap-2 text-xs font-semibold text-indigo-600 dark:text-indigo-300"><BookMarked className="h-3.5 w-3.5" />Decisiones similares del pasado</p>
      <ul className="space-y-2">{data.map((m) => (
        <li key={m.id} className="text-xs" data-testid={`${testid}-item`}>
          <span className={`mr-2 rounded px-1.5 py-0.5 text-[10px] font-bold ${VERDICT_META[m.outcome.verdict]?.cls}`}>{VERDICT_META[m.outcome.verdict]?.label}</span>
          <b className="text-slate-800 dark:text-slate-100">{m.title}</b>
          <p className="mt-0.5 text-slate-600 dark:text-slate-300">{m.lesson}</p>
        </li>))}</ul>
    </div>
  );
};
